export default (searchValue: string) => {
  return searchValue.split(",").map((item: string) => item.trim());
};
